export default __webpack_public_path__ + "static/media/atsuya-logo.d7764aef.svg";